"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadowSelector = void 0;
var __1 = require("../..");
var shadowSelector = function (props, intensity) {
    return props.theme.shadows["$" + intensity + "dp"](__1.convertHexToRGBValues(props.theme.variables.shadow));
};
exports.shadowSelector = shadowSelector;
var getShadow = function (intensity) {
    return function (props) { return exports.shadowSelector(props, intensity); };
};
exports.default = getShadow;
//# sourceMappingURL=index.js.map